import { AlignmentType, Header, ImageRun, Paragraph } from "docx";
import { getBase64FromUrl } from "../utils/WordExportUtils";

export const getHeader = async (isClientFacing = true) => {
  // For external/client-facing output, return empty header (no logo)
  if (isClientFacing) {
    return {
      headers: {
        default: new Header({
          children: [new Paragraph("")],
        }),
      },
    };
  }

  // For internal output, include PwC logo
  const base64Image = await getBase64FromUrl("/pwc_logo.png");

  return {
    headers: {
      default: new Header({
        children: [
          new Paragraph({
            alignment: AlignmentType.RIGHT,
            children: [
              new ImageRun({
                type: "png",
                data: base64Image,
                transformation: {
                  width: 100,
                  height: 62,
                },
              }),
            ],
          }),
        ],
      }),
    },
  };
};
